import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { USAGE_DURATION_ORDER, type UsageDurationKey } from '../utils/usageDuration'
import SelectionPickerGrid from './SelectionPickerGrid'
import ListingSpecCell from './ListingSpecCell'
import UsageDurationWheelPicker, { UsageDurationValueChip } from './UsageDurationWheelPicker'

interface UsageDurationPickerGridProps {
  value: string
  onChange: (value: UsageDurationKey) => void
  /** Sell builder history step — wheel + spec cell like battery health / cycles. */
  builderSpecCell?: boolean
}

export default function UsageDurationPickerGrid({
  value,
  onChange,
  builderSpecCell = false,
}: UsageDurationPickerGridProps) {
  const { t } = useTranslation()
  const options = useMemo(
    () =>
      USAGE_DURATION_ORDER.map((key) => ({
        value: key,
        title: t(`listing.usage.${key}`),
      })),
    [t],
  )

  if (builderSpecCell) {
    return (
      <div className="builder-usage-duration builder-usage-duration--spec">
        <div className="builder-battery-transparency__pickers-row builder-usage-duration__pickers-row">
          <ListingSpecCell
            tone="year"
            label={t('listing.builder.usageDurationTitle')}
            valueChip={<UsageDurationValueChip value={value} ariaLabel={t('listing.builder.usageDurationTitle')} />}
          >
            <UsageDurationWheelPicker
              compact
              showValueChip={false}
              value={value}
              onChange={onChange}
              ariaLabel={t('listing.builder.usageDurationTitle')}
            />
          </ListingSpecCell>
        </div>
      </div>
    )
  }

  return (
    <div className="builder-usage-duration-grid">
      <SelectionPickerGrid
        options={options}
        value={value}
        onChange={(next) => onChange(next as UsageDurationKey)}
        ariaLabel={t('listing.usageLegend')}
      />
    </div>
  )
}
